module.exports = __webpack_public_path__ + "static/media/400033_02.768be63e.png";